<template>
  <div class="wrp p-4" v-loading="isLoading" v-if="hasMammo">
    <div class="flex justify-between items-center mb-2">
      <h2>
        <h2>Breast-Expert 18: {{ $t("side_menu.lbl_mammo") }}</h2>
        <span v-show="reloading" class="ml-2 text-xs bg-green-300 text-green-800 italic transition-all duration-300">{{ $t("lbl_loading") }}...</span>
      </h2>
      <div class="border rounded-full p-2 cursor-pointer" @click="goBack">
        <svg data-v-2558e796 width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="cursor-pointer">
          <path data-v-2558e796 d="M6 18.4998L17.9998 6.5" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path data-v-2558e796 d="M17.9998 18.4998L6 6.5" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
    </div>
    <div class="rounded-xl bg-white p-3">
      <RISHeader :emrData="emrData" @setIsLoading="setIsLoading" />
      <div class="row mb-3">
        <div class="col-lg-6">
          <h3>
            <strong>{{ $t("title.lbl_right_breast") }}</strong>
          </h3>
          <div class="mb-3" v-for="(item, index) in filesR" :key="`${item.file_uid}-${item.id}-${actionCount}`">
            <div class="flex justify-between items-center pb-1 mb-2 border-b border-l-0 border-t-0 border-r-0 border-solid border-gray-200">
              <label class="font-bold">{{ $t(item.title) }}</label>
              <div v-if="!item.is_edit && item.file_uid" :set="(status = getStatus(item.status))">
                <el-tag size="mini" :type="status.type" effect="dark">{{ status.name }}</el-tag>
              </div>
            </div>
            <div v-if="item.is_edit || !item.file_uid">
              <label class="w-full">
                <input class="form-control border" type="file" accept=".dcm, application/dicom" @change="e => handleChangeFile(e, index, 'filesR')" />
              </label>
              <div class="flex flex-1 mt-2">
                <span class="mr-3 cursor-pointer hover:text-blue-600 transition-all duration-200" @click="() => handleUpdateFile(index, 'filesR')">
                  <i class="el-icon-upload mr-1" />
                  <span>{{ $t("button.upload") }}</span>
                </span>
                <span v-if="item.file_uid" class="cursor-pointer hover:text-red-500 transition-all duration-200" @click="() => handleToggleEdit(item, index, 'filesR')">
                  <i class="el-icon-close mr-1" />
                  <span>{{ $t("button.cancel") }}</span>
                </span>
              </div>
            </div>
            <div v-else>
              <div class="flex w-full overflow-hidden">
                <div class="mr-2">
                  <div class="w-12 h-12 rounded-lg flex bg-gray-200">
                    <i class="el-icon-paperclip text-2xl m-auto" />
                  </div>
                </div>
                <div class="flex-1" style="min-width: 0">
                  <div class="flex-1">
                    <div class="font-bold text-truncate">
                      {{ item.file_uid }}
                    </div>
                  </div>
                  <div class="flex-1 text-xs mb-2">
                    <label>{{ $t("title.lbl_added_by") }}</label>
                    <span class="text-blue-600 font-medium ml-1">
                      {{ item.upload_by_user && item.upload_by_user.name }}
                    </span>
                    <span>
                      -
                      {{ appUtils.formatDateTime(item.upload_at || item.created_at) }}
                    </span>
                  </div>
                  <div class="flex-1 mb-2" v-if="item.status === 2">
                    <div class="mb-1">
                      <label class="font-bold mr-1">{{ $t("title.status") }}:</label>
                      <span>
                        {{ item.data_decode && item.data_decode.Probs ? item.data_decode.Probs : "-" }}
                      </span>
                    </div>
                    <div>
                      <label class="font-bold mr-1">{{ $t("title.lbl_result") }}:</label>
                      <span>
                        {{ item.data_decode && item.data_decode.Result ? item.data_decode.Result : "-" }}
                      </span>
                    </div>
                  </div>
                  <div class="flex-1" v-if="item.status === 1">
                    <span class="cursor-pointer hover:text-blue-600 transition-all duration-200" @click="() => handleToggleEdit(item, index, 'filesR')">
                      <i class="el-icon-edit mr-1" />
                      <span>{{ $t("button.edit") }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <h3>
            <strong>{{ $t("title.lbl_left_breast") }}</strong>
          </h3>
          <div class="mb-3" v-for="(item, index) in filesL" :key="`${item.file_uid}-${item.id}-${actionCount}`">
            <div class="flex justify-between items-center pb-1 mb-2 border-b border-l-0 border-t-0 border-r-0 border-solid border-gray-200">
              <label class="font-bold">{{ $t(item.title) }}</label>
              <div v-if="!item.is_edit && item.file_uid" :set="(status = getStatus(item.status))">
                <el-tag size="mini" :type="status.type" effect="dark">{{ status.name }}</el-tag>
              </div>
            </div>
            <div v-if="item.is_edit || !item.file_uid">
              <label class="w-full">
                <input class="form-control border" type="file" accept=".dcm, application/dicom" @change="e => handleChangeFile(e, index, 'filesL')" />
              </label>
              <div class="flex flex-1 mt-2">
                <span class="mr-3 cursor-pointer hover:text-blue-600 transition-all duration-200" @click="() => handleUpdateFile(index, 'filesL')">
                  <i class="el-icon-upload mr-1" />
                  <span>{{ $t("button.upload") }}</span>
                </span>
                <span v-if="item.file_uid" class="cursor-pointer hover:text-red-500 transition-all duration-200" @click="() => handleToggleEdit(item, index, 'filesL')">
                  <i class="el-icon-close mr-1" />
                  <span>{{ $t("button.cancel") }}</span>
                </span>
              </div>
            </div>
            <div v-else>
              <div class="flex w-full overflow-hidden">
                <div class="mr-2">
                  <div class="w-12 h-12 rounded-lg flex bg-gray-200">
                    <i class="el-icon-paperclip text-2xl m-auto" />
                  </div>
                </div>
                <div class="flex-1" style="min-width: 0">
                  <div class="flex-1">
                    <div class="font-bold text-truncate">
                      {{ item.file_uid }}
                    </div>
                  </div>
                  <div class="flex-1 text-xs mb-2">
                    <label>{{ $t("title.lbl_added_by") }}</label>
                    <span class="text-blue-600 font-medium ml-1">
                      {{ item.upload_by_user && item.upload_by_user.name }}
                    </span>
                    <span>
                      -
                      {{ appUtils.formatDateTime(item.upload_at || item.created_at) }}
                    </span>
                  </div>
                  <div class="flex-1 mb-2" v-if="item.status === 2">
                    <div class="mb-1">
                      <label class="font-bold mr-1">{{ $t("title.status") }}:</label>
                      <span>
                        {{ item.data_decode && item.data_decode.Probs ? item.data_decode.Probs : "-" }}
                      </span>
                    </div>
                    <div>
                      <label class="font-bold mr-1">{{ $t("title.lbl_result") }}:</label>
                      <span>
                        {{ item.data_decode && item.data_decode.Result ? item.data_decode.Result : "-" }}
                      </span>
                    </div>
                  </div>
                  <div class="flex-1" v-if="item.status === 1">
                    <span class="cursor-pointer hover:text-blue-600 transition-all duration-200" @click="() => handleToggleEdit(item, index, 'filesL')">
                      <i class="el-icon-edit mr-1" />
                      <span>{{ $t("button.edit") }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <h3>
          <strong>{{ $t("title.lbl_image_result") }}</strong>
        </h3>
        <div v-if="emrData && emrData.viewer_url">
          <a :class="`btn btn-lg btn-primary ${emrData && !emrData.viewer_url && 'cursor-not-allowed disabled'}`" :href="emrData.viewer_url || '#'" target="_blank">
            <i class="el-icon-view text-xl" />
            <span class="ml-1">{{ $t("title.lbl_view_image_analysis") }}</span>
          </a>
        </div>
        <div v-else>
          <i class="el-icon-loading text-yellow-500" />
          <span class="ml-2 text-yellow-500">{{ $t("title.lbl_analyzing") }}</span>
        </div>
      </div>
      <div class="mb-3">
        <h3>
          <strong>{{ $t("title.doctor_conclusion") }}</strong>
        </h3>
        <!-- <div
          v-if="emrData && emrData.analysis_diagnose"
          v-html="emrData.analysis_diagnose"
        ></div>
        <div v-else>
          <i class="el-icon-loading text-yellow-500" />
          <span class="ml-2 text-yellow-500">Đang phân tích</span>
        </div>-->
        <div>
          <textarea v-model="analysis_diagnose" class="form-control border" rows="3"></textarea>
        </div>
      </div>
      <div class="mb-3">
        <h3>
          <strong>{{ $t("title.lbl_description_of_lesion_image") }}</strong>
        </h3>
        <div>
          <textarea v-model="diagnose" class="form-control border" rows="6"></textarea>
        </div>
      </div>
      <div class="text-center">
        <button class="btn btn-primary" @click="handleUpdateMammoCase">
          <span>{{ $t("lbl_save") }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import appUtils from '@/utils/appUtils'
import { mixinHasFeatures } from '@/utils/mixinHasFeatures'
import { v4 as uuid } from 'uuid'
import RISHeader from '../Common/RISHeader'

export default {
  name: 'DetailMammo',
  mixins: [mixinHasFeatures],
  components: { RISHeader },
  data () {
    return {
      isLoading: true,
      filesBase64: [],
      files: [],
      filesL: [],
      filesR: [],
      emrId: Number(this.$route.params?.id) || null,
      emrData: {},
      patientId: null,
      diagnose: '',
      analysis_diagnose: '',
      appUtils,
      actionCount: 0,
      timer: null,
      reloading: false
    }
  },
  async created () {
    const self = this
    await self.getEmrMammoData()

    // self.timer = setInterval(async () => {
    //   self.reloading = true
    //   await self.getEmrMammoData().then(() => {
    //     self.reloading = false
    //   })
    // }, 1000 * 30) // refetch 30s
  },
  mounted () {
    this.handleDefaultFiles()
  },
  watch: {
    '$route.params': {
      async handler (data) {
        const { id } = data
        if (!Number.isNaN(Number(id))) {
          this.emrId = id
        }
      },
      deep: true
    },
    emrData: {
      handler (data) {
        this.diagnose = data?.diagnose
        this.files = data.files
        this.filesR = []
        this.filesL = []
        this.analysis_diagnose = data?.analysis_diagnose

        // eslint-disable-next-line no-unused-expressions
        data.files?.map(file => {
          file.is_edit = false
          if ([1, 2].includes(file?.sub_file_type)) {
            this.filesR.push(file)
          } else if ([3, 4].includes(file?.sub_file_type)) {
            this.filesL.push(file)
          }
        })

        this.filesR.sort((a, b) => a.sub_file_type - b.sub_file_type)
        this.filesL.sort((a, b) => a.sub_file_type - b.sub_file_type)
      },
      deep: true
    }
  },
  methods: {
    cancelAutoUpdate () {
      clearInterval(this.timer)
    },
    async getEmrMammoData (emrId) {
      const id = emrId || this.emrId
      if (!id) return
      try {
        const res = await this.$rf.getRequest('RisRequest').getMammoDicomById(id)
        if (!res.data) return
        this.emrData = res.data
      } catch (error) {
        console.log(error)
      }
    },
    handleDefaultFiles () {
      this.files = [...Array(4).keys()].map((_, i) => ({
        file_uid: uuid(),
        title: i % 2 ? 'CC' : 'MLO',
        sub_file_type: i + 1,
        is_edit: false
      }))
      this.filesR = []
      this.filesL = []
      // eslint-disable-next-line no-unused-expressions
      this.files?.map(file => {
        if ([1, 2].includes(file?.sub_file_type)) {
          this.filesR.push(file)
        } else if ([3, 4].includes(file?.sub_file_type)) {
          this.filesL.push(file)
        }
      })
    },
    setIsLoading (value) {
      this.isLoading = value
    },
    goBack () {
      this.$router
        .replace({
          name: 'MammoDicomPage'
        })
        .catch(() => {})
    },
    handleChangeFile (e, index, fileType) {
      const self = this
      const file = e.target.files?.[0]
      if (!file) return

      appUtils.fileToBase64(file, function (base64String) {
        self[fileType][index] = {
          ...self[fileType][index],
          value: file,
          base64: base64String
        }
      })
    },
    async handleUpdateMammoCase () {
      const self = this

      try {
        self.isLoading = true
        const data = {
          diagnose: self.diagnose,
          analysis_diagnose: self.analysis_diagnose
        }
        const res = await self.$rf.getRequest('RisRequest').updateMammoDicomById(self.emrId, data)
        if (!res.data) return
        self.$message({ message: 'Cập nhật thành công!', type: 'success' })
      } catch (error) {
        console.log(error)
        self.$message({
          message: 'Đã xảy ra lỗi khi cập nhật!',
          type: 'error'
        })
      } finally {
        self.isLoading = false
      }
    },
    async handleUpdateFile (index, fileType) {
      const self = this
      try {
        this.isLoading = true

        const file = self[fileType][index] || null

        if (!file || !file?.id || !file?.base64) {
          self.$message({
            message: 'Bạn cần chọn hình ảnh trước khi tải lên.',
            type: 'error'
          })
          return
        }

        const fileData = {
          fileContent: file?.base64
        }

        const res = await self.$rf.getRequest('RisRequest').uploadMamoDicom(fileData)

        if (!res.data) return

        const file_uid = res.data?.sopInstanceUid

        if (!file_uid) {
          self.$message({
            message: 'Tải lên không thành công!',
            type: 'error'
          })
          return
        }

        const data = {
          file_uid,
          upload_at: Date.now()
        }

        const result = await this.handleUpdateMammoFileById(file?.id, data)
        if (!result) return

        self.getEmrMammoData()
        self.$message({ message: 'Tải lên thành công!', type: 'success' })
      } catch (error) {
        console.log(error)
        self.$message({
          message: 'Đã xảy ra lỗi khi tải file lên hệ thống!',
          type: 'error'
        })
      } finally {
        this.isLoading = false
      }
    },
    async handleUpdateMammoFileById (id, data) {
      try {
        const res = await this.$rf.getRequest('RisRequest').updateMammoDicomFileById(id, data)
        return res.data
      } catch (error) {
        console.log(error)
      }
    },
    handleToggleEdit (item, index, fileType) {
      this[fileType][index].is_edit = !item?.is_edit
      this.actionCount++
    },
    getStatus (value) {
      switch (value) {
        case 1:
          return {
            color: 'text-yellow-500',
            icon: 'el-icon-loading',
            type: 'warning',
            name: this.$t('title.lbl_processing')
          }
        case 2:
          return {
            color: 'text-green-500',
            icon: 'el-icon-success',
            type: 'success',
            name: this.$t('title.lbl_has_result')
          }
        default:
          return {
            color: 'text-red-500',
            icon: 'el-icon-error',
            type: 'danger',
            name: this.$t('title.lbl_unknown')
          }
      }
    }
  },
  destroyed () {
    this.cancelAutoUpdate()
  }
}
</script>
